import { createFileRoute } from "@tanstack/react-router";
import { useTicketTypeDrawerContext } from "@/utils/ticket-type-detail/ticket-type-drawer-context";
import { TicketTypeActivitySection } from "./fullActivity";

export const Route = createFileRoute(
	"/_authenticated/(org-app)/_orgAdmin/org-admin/$orgId/configuration/ticketTypes/$ticketTypeId/activity",
)({
	component: OrgTicketTypeActivityTab,
});

function OrgTicketTypeActivityTab() {
	const { ticketType } = useTicketTypeDrawerContext();

	return (
		<div className="p-4">
			<TicketTypeActivitySection ticketType={ticketType} />
		</div>
	);
}
